function ErrorComponent() {
  return <div>Unable to load merchants</div>;
}

export default ErrorComponent;
